import { Component } from 'react';
import React from 'react';
import RcColorPicker from 'rc-color-picker';
import { Button } from 'antd';
import 'rc-color-picker/assets/index.css';

export class ColorPicker extends Component<
    {
        onChange?: (value: any) => void;
        value?: any;
        defaultColor?: any;
    },
    never
> {
    originalColor = null;

    reset = () => {
        const { onChange, defaultColor } = this.props;
        onChange(defaultColor || this.originalColor);
    };

    onChange = (res: { color: any }) => {
        const { onChange } = this.props;
        onChange(res.color);
    };

    render() {
        const { value } = this.props;
        if (this.originalColor === null) {
            this.originalColor = value;
        }
        return (
            <div className={'color-picker'}>
                <RcColorPicker
                    className={'change-color'}
                    color={value}
                    onChange={this.onChange}
                    placement="bottomLeft"
                />
                <Button type={'link'} onClick={this.reset}>
                    重置
                </Button>
            </div>
        );
    }
}
